import { useGetCurrentUserQuery } from '../api/user.api';

export function useUserStatus() {
	const { data: user, isLoading } = useGetCurrentUserQuery();
	const isInactive = !!user && user.userStatus === 'INACTIVE';
	return { isInactive, isLoading };
}
